import cookie from 'cookie';
import {useTranslation} from 'react-i18next';

import {UserPreferencesPartialUpdateRequest} from '@br/idm-api';
import {useCustomerApi} from '@br/idm-components';
import {ActionsProps, SideMenuToggleCallback} from '@br/mg-components';

import {useNullableUserContext} from '../../../contexts/UserContext';
import {safeLoadJson} from '../../../utils/data';

export const useSideMenuCallback = (): SideMenuToggleCallback => {
    const {userPreferencesApi} = useCustomerApi();

    return (newState: boolean) => {
        const body: UserPreferencesPartialUpdateRequest = {
            patchedOIDCUserPreferencesRequest: {
                isNavPinned: newState,
            },
        };
        userPreferencesApi.userPreferencesPartialUpdate(body).catch(
            /* istanbul ignore next */ () => {
                throw new Error('Could not save preferences'); // eslint-disable-line i18next/no-literal-string
            }
        );
    };
};

/* istanbul ignore next */
export const getLanguages = (): [string, string][] => {
    return safeLoadJson('#languageSettings') || [];
};

/* istanbul ignore next */
export const setLanguage = (language: string) => {
    // eslint-disable-next-line i18next/no-literal-string
    document.cookie = cookie.serialize('django_language', language, {path: '/', sameSite: 'lax'});
    window.location.reload();
};

export const useUserActions = (): ActionsProps['userActions'] => {
    const user = useNullableUserContext();
    const {t} = useTranslation(['translation']);
    const actions = [];

    if (user) {
        const {partners, isSupportUser, tenants} = user;

        const hasMultipleRoles = [partners.length, isSupportUser, tenants.length].filter(Boolean).length >= 2;
        const hadMultipleOrganisations = tenants.length > 1 || partners.length > 1;

        if (hasMultipleRoles) {
            // eslint-disable-next-line i18next/no-literal-string
            actions.push({href: '/portal/', label: t('translation:switchRole', 'Switch Role')});
        }
        if (hadMultipleOrganisations && !hasMultipleRoles) {
            // eslint-disable-next-line i18next/no-literal-string
            actions.push({href: '/portal/', label: t('translation:switchOrganization', 'Switch Organization')});
        }
    }

    return actions;
};
